'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Drawer = require('../Drawer');

var _Drawer2 = _interopRequireDefault(_Drawer);

var _AppBar = require('../AppBar');

var _AppBar2 = _interopRequireDefault(_AppBar);

var _Toolbar = require('../Toolbar');

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Logo = require('../SvgIcon/Catalytic/Logo');

var _Logo2 = _interopRequireDefault(_Logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('AppDrawer', function (theme) {
  return _defineProperty({
    root: {
      display: 'flex',
      flex: 'none',
      flexDirection: 'column',
      overflowY: 'auto',
      maxWidth: '100%',
      width: theme.variables.drawerWidth,
      height: '100vh',
      backgroundColor: theme.palette.drawer.background.primary,
      transition: theme.transitions.create('width')
    },
    toolbar: {
      maxWidth: '100%',
      width: theme.variables.drawerWidth,
      backgroundColor: theme.palette.drawer.background.primary,
      backgroundImage: _Logo2['default'].toURL(),
      backgroundRepeat: 'no-repeat',
      backgroundSize: theme.typography.rhythmByUnit(5) + '\n                     ' + theme.typography.rhythmByUnit(5),
      backgroundPosition: theme.typography.rhythmByUnit(2),
      transition: theme.transitions.create('width')
    },
    list: {
      flex: '1 1 100%'
    },
    childRoot: Object.assign({
      height: theme.typography.rhythmByPixel(30),
      color: theme.palette.drawer.text.primary,
      transition: theme.transitions.create(['background-color', 'color'])
    }, theme.mixins.gutters(3), theme.typography.verticalScaledRhythmByPixel(14), {
      '&:focus, &:hover': {
        backgroundColor: theme.palette.drawer.background.active,
        color: theme.palette.drawer.text.active,
        '& svg': {
          color: theme.palette.drawer.icon.active
        }
      },
      '&[target=_blank]': {
        '&:focus': {
          backgroundColor: 'transparent',
          color: theme.palette.drawer.text.primary,
          '& svg': {
            color: theme.palette.drawer.icon.primary
          }
        },
        '&:hover': {
          backgroundColor: theme.palette.drawer.background.active,
          color: theme.palette.drawer.text.active,
          '& svg': {
            color: theme.palette.drawer.icon.active
          }
        }
      },
      '& svg': {
        width: theme.typography.rhythmByUnit(2),
        height: theme.typography.rhythmByUnit(2),
        color: theme.palette.drawer.icon.primary,
        transition: theme.transitions.create('color')
      }
    }),
    selected: {
      '&, &:focus, &:hover': {
        backgroundColor: theme.palette.drawer.background.active,
        color: theme.palette.drawer.text.active,
        '& svg': {
          color: theme.palette.drawer.icon.active
        }
      }
    }
  }, theme.breakpoints.up('lg'), {
    root: {
      width: theme.variables.drawerWidthLarge
    },
    toolbar: {
      width: theme.variables.drawerWidthLarge
    }
  });
});

var AppDrawer = (_temp2 = _class = function (_PureComponent) {
  _inherits(AppDrawer, _PureComponent);

  function AppDrawer() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, AppDrawer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = AppDrawer.__proto__ || Object.getPrototypeOf(AppDrawer)).call.apply(_ref2, [this].concat(args))), _this), _this.renderList = function (icon) {
      var _this$props = _this.props,
          children = _this$props.children,
          onRequestClose = _this$props.onRequestClose;

      var classes = _this.context.styleManager.render(styleSheet);
      var logo = _this.renderLogo(icon);

      return _react2['default'].createElement(
        'nav',
        null,
        logo,
        _react.Children.map(children, function (child) {
          var _child$props = child.props,
              className = _child$props.className,
              _onClick = _child$props.onClick,
              selected = _child$props.selected;

          var childProps = {
            className: (0, _classnames2['default'])(classes.childRoot, _defineProperty({}, classes.selected, selected), className),
            onClick: function () {
              function onClick(e) {
                if (_onClick) {
                  _onClick(e);
                }
                onRequestClose(e);
              }

              return onClick;
            }()
          };

          return _react2['default'].cloneElement(child, childProps);
        })
      );
    }, _this.renderLogo = function (Icon) {
      var classes = _this.context.styleManager.render(styleSheet);
      var appBar = _react2['default'].createElement(
        _AppBar2['default'],
        null,
        _react2['default'].createElement(_Toolbar2['default'], {
          className: classes.toolbar,
          gutters: false,
          style: { backgroundImage: Icon.toURL() }
        })
      );

      if (_this.props.homeLink) {
        return _react2['default'].createElement(
          'a',
          { href: _this.props.homeLink, property: 'homeLink', 'typeof': 'ui:AppDrawer' },
          appBar
        );
      }

      return appBar;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AppDrawer, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            className = _props.className,
            Icon = _props.icon,
            onRequestClose = _props.onRequestClose,
            open = _props.open,
            permanent = _props.permanent;

        var classes = this.context.styleManager.render(styleSheet);

        if (permanent) {
          return _react2['default'].createElement(
            'div',
            { className: classes.root },
            this.renderList(Icon)
          );
        } else {
          return _react2['default'].createElement(
            _Drawer2['default'],
            _extends({
              paperClassName: classes.root
            }, { className: className, onRequestClose: onRequestClose, open: open }),
            this.renderList(Icon)
          );
        }
      }

      return render;
    }()
  }]);

  return AppDrawer;
}(_react.PureComponent), _class.propTypes = {
  /**
   * Can be any node or number of nodes.
   */
  children: _PropTypes2['default'].node,
  className: _PropTypes2['default'].string,
  /**
   * Href for when logo area is clicked on medium+
   */
  homeLink: _PropTypes2['default'].string,
  /**
   * Icon for logo area
   */
  icon: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  onRequestClose: _PropTypes2['default'].func.isRequired,
  open: _PropTypes2['default'].bool.isRequired,
  permanent: _PropTypes2['default'].bool.isRequired
}, _class.defaultProps = {
  icon: _Logo2['default'],
  onRequestClose: function () {
    function onRequestClose() {}

    return onRequestClose;
  }()
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = AppDrawer;


AppDrawer.displayName = 'AppDrawer';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/AppDrawer/index.js
// module id = 1618
// module chunks = 32